import React, { useState } from 'react';

const Elevenththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Midnight Royal */
            --primary: #1e3a8a;       /* Royal Blue */
            --primary-dark: #172554;  /* Midnight Blue */
            --primary-light: #3b82f6; /* Bright Blue */
            --accent: #d4af37;        /* Gold */
            --bg-body: #f8fafc;       /* Off-white */
            --bg-white: #ffffff;
            --text-dark: #0f172a;     /* Dark Slate */
            --text-muted: #64748b;    /* Slate */
            
            --font-head: 'Cinzel', serif;
            --font-body: 'Montserrat', sans-serif;

            --radius-sm: 4px;
            --radius-md: 8px;
            --shadow-card: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
            --shadow-hover: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: var(--font-body);
            color: var(--text-dark);
            background-color: var(--bg-body);
            line-height: 1.6;
        }

        h1, h2, h3, h4, h5 {
            font-family: var(--font-head);
            color: var(--primary-dark);
            line-height: 1.2;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: all 0.3s ease;
        }

        ul {
            list-style: none;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
        }

        .section {
            padding: 100px 0;
        }

        /* Buttons */
        .btn {
            display: inline-block;
            padding: 14px 32px;
            background-color: var(--primary);
            color: var(--accent);
            text-transform: uppercase;
            font-weight: 600;
            letter-spacing: 1px;
            border: 1px solid var(--primary);
            border-radius: var(--radius-sm);
            cursor: pointer;
            transition: all 0.3s ease;
        }

        .btn:hover {
            background-color: var(--primary-dark);
            color: #fff;
            transform: translateY(-2px);
        }

        .btn-outline {
            background-color: transparent;
            color: var(--primary);
            border: 1px solid var(--primary);
        }

        .btn-outline:hover {
            background-color: var(--primary);
            color: var(--accent);
        }

        /* Top Bar */
        .top-bar {
            background-color: var(--primary-dark);
            color: #cbd5e1;
            padding: 10px 0;
            font-size: 0.9rem;
        }

        .top-bar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .contact-list {
            display: flex;
            gap: 20px;
        }

        .contact-list span {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .contact-list i {
            color: var(--accent);
        }

        /* Navbar */
        .navbar {
            background-color: var(--bg-white);
            padding: 20px 0;
            box-shadow: 0 2px 10px rgba(0,0,0,0.05);
            position: sticky;
            top: 0;
            z-index: 1000;
        }

        .navbar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .brand {
            font-size: 1.8rem;
            font-weight: 700;
            color: var(--primary-dark);
            text-transform: uppercase;
            letter-spacing: 2px;
            border-bottom: 2px solid var(--accent);
            padding-bottom: 5px;
        }

        .nav-links {
            display: flex;
            gap: 30px;
        }

        .nav-links a {
            font-weight: 500;
            color: var(--primary-dark);
            text-transform: uppercase;
            font-size: 0.9rem;
            letter-spacing: 1px;
            position: relative;
        }

        .nav-links a::after {
            content: '';
            position: absolute;
            width: 0;
            height: 2px;
            bottom: -5px;
            left: 0;
            background-color: var(--accent);
            transition: width 0.3s;
        }

        .nav-links a:hover::after {
            width: 100%;
        }

        /* Hero */
        .hero {
            height: 80vh;
            background: linear-gradient(rgba(23, 37, 84, 0.8), rgba(23, 37, 84, 0.6)), url('https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80') center/cover fixed;
            display: flex;
            align-items: center;
            text-align: center;
            color: var(--bg-white);
        }

        .hero-content {
            max-width: 800px;
            margin: 0 auto;
        }

        .hero-subtitle {
            display: block;
            color: var(--accent);
            font-size: 1.1rem;
            text-transform: uppercase;
            letter-spacing: 4px;
            margin-bottom: 20px;
        }

        .hero h1 {
            font-size: 4rem;
            color: var(--bg-white);
            margin-bottom: 30px;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }

        .hero p {
            font-size: 1.2rem;
            margin-bottom: 40px;
            color: #cbd5e1;
            font-weight: 300;
        }

        /* Headings */
        .section-header {
            text-align: center;
            margin-bottom: 60px;
        }

        .section-tag {
            color: var(--accent);
            font-size: 0.9rem;
            text-transform: uppercase;
            letter-spacing: 2px;
            font-weight: 600;
            display: block;
            margin-bottom: 15px;
        }

        .section-title {
            font-size: 2.5rem;
            position: relative;
            display: inline-block;
            padding-bottom: 15px;
        }

        .section-title::after {
            content: '';
            position: absolute;
            width: 60px;
            height: 3px;
            background-color: var(--accent);
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
        }

        /* Services */
        .services-section {
            background-color: #f1f5f9;
        }

        .service-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 30px;
        }

        .service-card {
            background: var(--bg-white);
            padding: 40px 30px;
            border-radius: var(--radius-md);
            text-align: center;
            box-shadow: var(--shadow-card);
            transition: all 0.3s;
            border-top: 4px solid transparent;
        }

        .service-card:hover {
            transform: translateY(-5px);
            box-shadow: var(--shadow-hover);
            border-top-color: var(--accent);
        }

        .service-icon {
            width: 80px;
            height: 80px;
            margin: 0 auto 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background-color: rgba(212, 175, 55, 0.1);
            color: var(--accent);
            font-size: 2rem;
        }
        
        .service-icon img {
             width: 100%;
             height: 100%;
             border-radius: 50%;
             object-fit: cover;
        }

        .service-card h3 {
            font-size: 1.4rem;
            margin-bottom: 15px;
        }

        .service-card p {
            color: var(--text-muted);
            margin-bottom: 25px;
            font-size: 0.95rem;
        }

        /* Products */
        .product-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 30px;
        }

        .product-card {
            background: var(--bg-white);
            border-radius: var(--radius-md);
            overflow: hidden;
            box-shadow: var(--shadow-card);
            transition: all 0.3s;
            display: flex;
            flex-direction: column;
        }

        .product-card:hover {
            box-shadow: var(--shadow-hover);
        }

        .product-img {
            height: 220px;
            overflow: hidden;
            position: relative;
        }

        .product-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s;
        }

        .product-card:hover .product-img img {
            transform: scale(1.1);
        }
        
        .product-price {
            position: absolute;
            top: 15px;
            right: 15px;
            background-color: var(--primary-dark);
            color: var(--accent);
            padding: 5px 10px;
            font-weight: 700;
            border-radius: var(--radius-sm);
        }

        .product-content {
            padding: 25px;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
        }

        .product-content h3 {
            font-size: 1.25rem;
            margin-bottom: 10px;
        }
        
        .product-content p {
            color: var(--text-muted);
            font-size: 0.9rem;
            margin-bottom: 20px;
            flex-grow: 1;
        }

        .product-actions {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        /* Testimonials */
        .testimonial-section {
            background-color: var(--primary-dark);
            color: var(--bg-white);
            background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23d4af37' fill-opacity='0.05' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='3'/%3E%3Ccircle cx='13' cy='13' r='3'/%3E%3C/g%3E%3C/svg%3E");
        }

        .testimonial-section .section-title, 
        .testimonial-section .section-tag {
            color: var(--bg-white);
        }
        
        .testimonial-section .section-title::after {
            background-color: var(--accent);
        }

        .review-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 40px;
        }

        .review-card {
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.1);
            padding: 40px;
            border-radius: var(--radius-md);
            position: relative;
        }

        .quote-mark {
            font-family: serif;
            font-size: 4rem;
            color: var(--accent);
            opacity: 0.3;
            position: absolute;
            top: 20px;
            left: 20px;
            line-height: 1;
        }

        .review-text {
            font-size: 1.1rem;
            font-style: italic;
            margin-bottom: 20px;
            position: relative;
            z-index: 1;
            line-height: 1.8;
        }
        
        .review-author {
            display: flex;
            align-items: center;
            gap: 15px;
        }
        
        .author-avatar {
            width: 50px;
            height: 50px;
            background-color: var(--accent);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--primary-dark);
            font-weight: 700;
            font-size: 1.2rem;
        }
        
        .author-info h4 {
            color: var(--bg-white);
            font-size: 1rem;
            margin-bottom: 2px;
        }
        
        .author-info span {
            color: var(--accent);
            font-size: 0.8rem;
            text-transform: uppercase;
        }

        /* Footer */
        footer {
            background-color: #0f172a;
            color: #94a3b8;
            padding: 80px 0 20px;
            border-top: 3px solid var(--accent);
        }

        .footer-grid {
            display: grid;
            grid-template-columns: 2fr 1fr 1fr 1.5fr;
            gap: 40px;
            margin-bottom: 60px;
        }

        .footer-logo {
            font-family: var(--font-head);
            font-size: 2rem;
            color: var(--bg-white);
            margin-bottom: 20px;
            display: block;
        }
        
        .footer-logo span {
            color: var(--accent);
        }

        .footer-col h4 {
            color: var(--bg-white);
            font-size: 1.1rem;
            margin-bottom: 25px;
            text-transform: uppercase;
            letter-spacing: 1px;
        }

        .footer-links li {
            margin-bottom: 12px;
        }

        .footer-links a:hover {
            color: var(--accent);
            padding-left: 5px;
        }

        .footer-contact li {
            display: flex;
            gap: 10px;
            margin-bottom: 15px;
        }
        
        .footer-contact i {
            color: var(--accent);
        }

        .social-icons {
            display: flex;
            gap: 15px;
            margin-top: 25px;
        }

        .social-icon {
            width: 36px;
            height: 36px;
            border: 1px solid #334155;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s;
        }

        .social-icon:hover {
            background-color: var(--accent);
            border-color: var(--accent);
            color: var(--primary-dark);
        }

        .copyright {
            text-align: center;
            padding-top: 30px;
            border-top: 1px solid #1e293b;
            font-size: 0.9rem;
        }

        @media (max-width: 900px) {
            .service-grid, .product-grid, .review-grid, .footer-grid {
                grid-template-columns: 1fr;
            }
            .hero h1 {
                font-size: 2.8rem;
            }
            .nav-links, .top-bar {
                display: none;
            }
            .navbar .container {
                justify-content: center;
            }
        }
            `}</style>
            
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700&family=Montserrat:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            {/* Top Bar */}
            <div className="top-bar">
                <div className="container">
                    <div className="contact-list">
                        {get_data.business_location_name && <span><i>📍</i> {get_data.business_location_name}</span>}
                        {get_data.mobile && <span><i>📞</i> {get_data.mobile}</span>}
                        {get_data.email && <span><i>✉️</i> {get_data.email}</span>}
                    </div>
                </div>
            </div>

            {/* Navbar */}
            <nav className="navbar">
                <div className="container">
                    <a href="#" className="brand">{get_data.service_name}</a>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#about">About</a>
                        <a href="#services">Services</a>
                        <a href="#products">Products</a>
                        <a href="#reviews">Reviews</a>
                        <a href="#contact">Contact</a>
                    </div>
                </div>
            </nav>

            {/* Hero */}
            <header className="hero">
                <div className="container">
                    <div className="hero-content">
                        <span className="hero-subtitle">Premium Excellence</span>
                        <h1>Uncompromising Quality & Service</h1>
                        <p>Experience the finest standard in our industry. We are dedicated to delivering superior results for our distinguished clients.</p>
                        <a href="#services" className="btn">Discover More</a>
                    </div>
                </div>
            </header>

             {/* About Section */}
             <section className="section" id="about">
                <div className="container">
                    <div style={{display: 'flex', gap: '50px', alignItems: 'center', flexWrap: 'wrap'}}>
                        <div style={{flex: 1, minWidth: '300px'}}>
                            <img src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80" alt="About" style={{width: '100%', borderRadius: '8px', boxShadow: 'var(--shadow-hover)'}} />
                        </div>
                        <div style={{flex: 1, minWidth: '300px'}}>
                            <div className="section-header" style={{textAlign: 'left', margin: 0}}>
                                <span className="section-tag">About Us</span>
                                <h2 className="section-title">A Legacy of Trust</h2>
                            </div>
                            <p style={{marginTop: '30px', color: 'var(--text-muted)', fontSize: '1.1rem', lineHeight: '1.8'}}>
                                Founded on the principles of integrity and excellence, {get_data.service_name} has established itself as a leader in the market. We combine traditional values with modern innovation to provide solutions that stand the test of time.
                            </p>
                            <p style={{marginTop: '20px', color: 'var(--text-muted)', fontSize: '1.1rem', lineHeight: '1.8'}}>
                                Our team of dedicated professionals is committed to exceeding your expectations at every turn.
                            </p>
                            <div style={{marginTop: '40px'}}>
                                <a href="#contact" className="btn btn-outline">Get in Touch</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services */}
            <section className="section services-section" id="services">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">What We Do</span>
                        <h2 className="section-title">Our Expertise</h2>
                    </div>
                    <div className="service-grid">
                        {get_data.categories && get_data.categories.map((item, index) => (
                            <div className="service-card" key={index}>
                                <div className="service-icon">
                                     {item.icon ? (
                                        <img 
                                            src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`}
                                            alt={item.name}
                                        />
                                    ) : (
                                        <span>◈</span>
                                    )}
                                </div>
                                <h3>{item.name}</h3>
                                <p>{item.description || 'Professional service description.'}</p>
                                <div style={{display: 'flex', gap: '10px', justifyContent: 'center'}}>
                                    <a href={`tel:${get_data.mobile}`} className="btn btn-outline" style={{padding: '10px 20px', fontSize: '0.8rem'}}>Call</a>
                                    <a href="#contact" className="btn" style={{padding: '10px 20px', fontSize: '0.8rem', color: '#fff'}}>Enquiry</a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Products */}
            <section className="section" id="products">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">The Collection</span>
                        <h2 className="section-title">Featured Products</h2>
                    </div>
                    <div className="product-grid">
                         {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="product-card" key={index}>
                                <div className="product-img">
                                    <img 
                                        src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                        alt={item.service_name}
                                    />
                                    {item.price && <div className="product-price">₹{item.price}</div>}
                                </div>
                                <div className="product-content">
                                    <h3>{item.service_name}</h3>
                                    <p>{item.description || 'Premium quality item.'}</p>
                                    <div className="product-actions">
                                        <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', textAlign: 'center', color: '#fff'}}>Order Now</button>
                                        <div style={{display: 'flex', gap: '10px'}}>
                                            <a href={`tel:${get_data.mobile}`} className="btn btn-outline" style={{flex: 1, textAlign: 'center', padding: '10px'}}>Call</a>
                                            <a href="#contact" className="btn btn-outline" style={{flex: 1, textAlign: 'center', padding: '10px'}}>Enquiry</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            <section className="section testimonial-section" id="reviews">
                <div className="container">
                    <div className="section-header">
                        <span className="section-tag">Client Feedback</span>
                        <h2 className="section-title">Trusted Excellence</h2>
                    </div>
                    {get_data.review_ratings && get_data.review_ratings.length > 0 ? (
                        <div className="review-grid">
                             {get_data.review_ratings.map((review, index) => (
                                <div className="review-card" key={index}>
                                    <div className="quote-mark">“</div>
                                    <div style={{color: 'var(--accent)', marginBottom: '15px'}}>
                                         {review.rating && <span>{'★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating))}</span>}
                                    </div>
                                    <p className="review-text">"{review.review || 'Excellent service.'}"</p>
                                    <div className="review-author">
                                        <div className="author-avatar">{review.user_name ? review.user_name.charAt(0) : 'U'}</div>
                                        <div className="author-info">
                                            <h4>{review.user_name || 'Valued Client'}</h4>
                                            <span>Verified</span>
                                        </div>
                                    </div>
                                </div>
                             ))}
                        </div>
                    ) : (
                        <div style={{textAlign: 'center', opacity: 0.7}}><p>No reviews available yet.</p></div>
                    )}
                </div>
            </section>

            {/* Footer */}
            <footer id="contact">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-col">
                            <a href="#" className="footer-logo">{get_data.service_name}<span>.</span></a>
                            <p>We are dedicated to providing the highest level of service and quality products. Your satisfaction is our priority.</p>
                            <div className="social-icons">
                                {get_data.facebook && <a href={get_data.facebook} className="social-icon">f</a>}
                                {get_data.twitter && <a href={get_data.twitter} className="social-icon">t</a>}
                                {get_data.instagram && <a href={get_data.instagram} className="social-icon">ig</a>}
                                {get_data.youtube && <a href={get_data.youtube} className="social-icon">yt</a>}
                            </div>
                        </div>
                        <div className="footer-col">
                            <h4>Quick Links</h4>
                            <ul className="footer-links">
                                <li><a href="#">Home</a></li>
                                <li><a href="#about">About Us</a></li>
                                <li><a href="#services">Services</a></li>
                                <li><a href="#products">Products</a></li>
                                <li><a href="#reviews">Testimonials</a></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Services</h4>
                            <ul className="footer-links">
                                <li><a href="#services">All Services</a></li>
                                <li><a href="#products">Our Products</a></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Contact Info</h4>
                            <ul className="footer-contact">
                                <li>
                                    <i>📍</i>
                                    <span>{get_data.business_location_name}</span>
                                </li>
                                <li>
                                    <i>📞</i>
                                    <span>{get_data.mobile}</span>
                                </li>
                                <li>
                                    <i>✉️</i>
                                    <span>{get_data.email}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="copyright">
                        <p>&copy; {new Date().getFullYear()} {get_data.service_name || 'Partner Company'}. All Rights Reserved.</p>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Elevenththeme;
